"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var _Card = _interopRequireDefault(require("../../Card/Card"));
var _currency = require("../../../currency");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FlexTierCards = function FlexTierCards(props) {
  var tierCards = props.tierCards,
    title = props.title;
  return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, title && /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-center margin-bottom-xl"
  }, title), tierCards.length && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-l-auto-grid"
  }, tierCards.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_Card["default"], {
      template: item.image ? 'ImageCard' : 'BasicCard',
      imageCardTemplate: "VerticalSplit",
      image: item.image
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-component"
    }, item.title && /*#__PURE__*/_react["default"].createElement("h3", {
      className: "text-md d8-u-color-primary d8-u-ls-sm"
    }, item.title), item.price && /*#__PURE__*/_react["default"].createElement("h4", {
      className: (0, _classnames["default"])('text-md', 'd8-u-ls-sm')
    }, /*#__PURE__*/_react["default"].createElement(_currency.FormatCurrency, {
      amount: typeof item.price !== 'number' ? parseFloat(item.price.replace(/[^\d.]/g, '')) : item.price,
      baseCurrency: "EUR"
    }), "pp"), item.priceinfo && /*#__PURE__*/_react["default"].createElement("p", {
      className: "d8-u-color-contrast-high text-sm d8-u-text-bold d8-u-ls-sm"
    }, item.priceinfo), item.text && /*#__PURE__*/_react["default"].createElement("p", null, item.text), /*#__PURE__*/_react["default"].createElement("ul", {
      className: "no-style"
    }, item.list && item.list.map(function (listItem) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: JSON.stringify(listItem),
        className: "d8-u-color-contrast-high text-sm"
      }, listItem.text);
    }))));
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "mt10 tac"
  }, "* Prices based on a yacht for 8 guests")));
};
FlexTierCards.propTypes = {
  tierCards: _propTypes["default"].array.isRequired,
  title: _propTypes["default"].string
};
var _default = exports["default"] = FlexTierCards;